<template>
  <b-form>
    <div
      class="row mb-1 pb-3 border-bottom g-0"
      style="--bs-border-color: black"
    >
      <div class="col-md-12 d-flex align-items-center">
        <span class="fw-bold">Kemajuan Perizinan Yang Diperoleh</span>
      </div>
    </div>
    <span>Kemajuan dalam memperoleh:</span>

    <div class="row mb-2 mt-3">
      <div :class="['col-md-6', { 'pe-none': is_selesai }]">
        <div class="row gx-3">
          <div class="col-12">
            <label class="fw-bold"
              >a. persetujuan lingkungan
              <span class="text-danger">*</span>
            </label>
            <div class="w-50 pe-2">
              <v-select
                v-model="form.persetujuan_lingkungan"
                id="a_persetujuan_lingkungan"
                :reduce="(data) => data.value"
                label="text"
                :options="optionPersetujuanLingkungan"
                name="Persetujuan Lingkungan"
                v-validate="'required'"
                :class="{
                  input: true,
                  'is-danger': errors.has('Persetujuan Lingkungan'),
                }"
              />
            </div>
            <span
              class="text-danger"
              v-if="errors.has('Persetujuan Lingkungan')"
            >
              {{ errors.first('Persetujuan Lingkungan') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="form.persetujuan_lingkungan === 'Sudah'" class="row mb-3">
      <div :class="['col-md-6', { 'pe-none': is_selesai }]">
        <div class="row gx-3">
          <div class="row">
            <div class="col-6 mt-3 g-3">
              <label>Nomor Perizinan <span class="text-danger">*</span></label>
              <b-form-input
                v-model="form.a_nomor_perizinan"
                id="a_nomor_perizinan"
                v-validate="'required'"
                name="Nomor Perizinan"
                :class="{
                  input: true,
                  'is-danger': errors.has('Nomor Perizinan'),
                }"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Nomor Perizinan')">
                {{ errors.first('Nomor Perizinan') }}
              </span>
            </div>
            <div class="col-6 mt-3 g-3">
              <label>Tanggal Terbit <span class="text-danger">*</span></label>
              <DatePicker
                id="a_tgl_terbit"
                lang="en"
                :placeholder="a_tgl_terbit"
                input-class="form-control"
                @change="
                  (val) => {
                    this.a_tgl_terbit = val.toLocaleDateString('en-GB')
                    this.form.a_tgl_terbit = formatDate(val, 'YYYY-MM-DD')
                    this.errors.remove('Tanggal Terbit')
                  }
                "
                class="w-100"
              >
                <i class="fa fa-calendar-o" slot="calendar-icon" />
              </DatePicker>
              <span class="text-danger" v-if="errors.has('Tanggal Terbit')">
                {{ errors.first('Tanggal Terbit') }}
              </span>
            </div>
            <div class="col-6 mt-3 g-3">
              <label
                >Instansi Penerbit <span class="text-danger">*</span></label
              >
              <b-form-input
                v-model="form.a_instansi_penerbit"
                id="a_instansi_penerbit"
                v-validate="'required'"
                name="Instansi Penerbit"
                :class="{
                  input: true,
                  'is-danger': errors.has('Instansi Penerbit'),
                }"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Instansi Penerbit')">
                {{ errors.first('Instansi Penerbit') }}
              </span>
            </div>
            <div class="col-6 mt-3 g-3">
              <label
                >Masa Berlaku (tahun) <span class="text-danger">*</span></label
              >
              <div class="input-units">
                <b-form-input
                  v-model="form.a_masa_berlaku"
                  id="a_masa_berlaku"
                  v-mask="integerMask(form.a_masa_berlaku)"
                  v-validate="'required'"
                  name="Masa Berlaku"
                  :class="{
                    input: true,
                    'is-danger': errors.has('Masa Berlaku'),
                  }"
                ></b-form-input>
                <div class="text-units">
                  <span>{{ form.a_masa_berlaku }}</span>
                  <span> tahun</span>
                </div>
              </div>
              <span class="text-danger" v-if="errors.has('Masa Berlaku')">
                {{ errors.first('Masa Berlaku') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label> Upload dokumentasi/bukti dukung </label>
        <div class="row">
          <div>
            <small>Format file: PDF, Ukuran maksimal: 5MB</small>
          </div>
          <div class="col-6">
            <b-form-file
              v-model="form.a_dokumentasi"
              id="a_dokumentasi"
              plain
              class="form-control"
              name="a. Dokumentasi"
              accept=".pdf"
              @change="checkFileSize($event, 'dokumentasi-a')"
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div v-if="a_url_dokumentasi" class="col-6 d-flex">
            <a
              :class="{
                'btn btn-success': true,
                disabled: a_url_dokumentasi === null,
              }"
              :href="a_url_dokumentasi"
              target="_blank"
            >
              <i class="fa fa-download" />
              Unduh
            </a>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Dokumentasi')">
          {{ errors.first('Dokumentasi') }}
        </span>
        <span class="text-danger" v-if="errors.has('dokumentasi-a', 'custom')">
          {{ errors.first('dokumentasi-a', 'custom') }}
        </span>
      </div>
    </div>
    <div class="row mb-1 pb-3 border-bottom g-0"></div>

    <template v-if="jenis_kegiatan === 'Berusaha'">
      <div class="row mb-3 mt-3">
        <div :class="['col-md-6', { 'pe-none': is_selesai }]">
          <div class="row gx-3">
            <div class="col-12">
              <label class="fw-bold">
                b. perizinan berusaha <span class="text-danger">*</span></label
              >
              <div class="w-50 pe-2">
                <v-select
                  v-model="form.perizinan_berusaha"
                  id="b_perizinan_berusaha"
                  :reduce="(data) => data.value"
                  label="text"
                  :options="optionPerizinanBerusaha"
                  name="Perizinan Berusaha"
                  v-validate="'required'"
                />
              </div>
              <span class="text-danger" v-if="errors.has('Perizinan Berusaha')">
                {{ errors.first('Perizinan Berusaha') }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <template v-if="form.perizinan_berusaha === 'Sudah'">
        <div v-for="(data, index) in form.data_perizinan_berusaha" :key="index">
          <div v-if="index !== 0" class="row border-bottom g-0 mb-3"></div>
          <div class="row mb-3">
            <div :class="['col-md-6', { 'pe-none': is_selesai }]">
              <div class="row gx-3">
                <div class="fw-bold">Perizinan Berusaha {{ index + 1 }}</div>
                <div class="row">
                  <div></div>
                  <div class="col-6 mt-3 g-3">
                    <label
                      >Nomor Perizinan Berusaha {{ index + 1 }}
                      <span class="text-danger">*</span></label
                    >
                    <b-form-input
                      v-model="data.nomor_perizinan"
                      :id="`b_nomor_perizinan_${index + 1}`"
                      v-validate="'required'"
                      :name="`Nomor Perizinan Berusaha ${index + 1}`"
                    ></b-form-input>
                    <span
                      class="text-danger"
                      v-if="errors.has(`Nomor Perizinan Berusaha ${index + 1}`)"
                    >
                      {{
                        errors.first(`Nomor Perizinan Berusaha ${index + 1}`)
                      }}
                    </span>
                  </div>
                  <div class="col-6 mt-3 g-3">
                    <label
                      >Tanggal Terbit Perizinan Berusaha {{ index + 1 }}
                      <span class="text-danger">*</span></label
                    >
                    <DatePicker
                      :id="`b_tgl_terbit_${index + 1}`"
                      lang="en"
                      :placeholder="b_tgl_terbit[index]"
                      input-class="form-control"
                      @change="
                        (e) => {
                          changeDatePerizinanBerusaha(e, index)
                        }
                      "
                      class="w-100"
                    >
                      <i class="fa fa-calendar-o" slot="calendar-icon" />
                    </DatePicker>
                    <span
                      class="text-danger"
                      v-if="
                        errors.has(
                          `Tanggal Terbit Perizinan Berusaha ${index + 1}`
                        )
                      "
                    >
                      {{
                        errors.first(
                          `Tanggal Terbit Perizinan Berusaha ${index + 1}`
                        )
                      }}
                    </span>
                  </div>
                  <div class="col-6 mt-3 g-3">
                    <label
                      >Instansi Penerbit Perizinan Berusaha {{ index + 1 }}
                      <span class="text-danger">*</span></label
                    >
                    <b-form-input
                      v-model="data.instansi_penerbit"
                      :id="`b_instansi_penerbit_${index + 1}`"
                      v-validate="'required'"
                      :name="`Instansi Penerbit Perizinan Berusaha ${
                        index + 1
                      }`"
                    ></b-form-input>
                    <span
                      class="text-danger"
                      v-if="
                        errors.has(
                          `Instansi Penerbit Perizinan Berusaha ${index + 1}`
                        )
                      "
                    >
                      {{
                        errors.first(
                          `Instansi Penerbit Perizinan Berusaha ${index + 1}`
                        )
                      }}
                    </span>
                  </div>
                  <div class="col-6 mt-3 g-3">
                    <label
                      >Masa Berlaku Perizinan Berusaha {{ index + 1 }} (tahun)
                      <span class="text-danger">*</span></label
                    >
                    <div class="input-units">
                      <b-form-input
                        v-model="data.masa_berlaku"
                        :id="`b_masa_berlaku_${index + 1}`"
                        v-mask="integerMask(data.masa_berlaku)"
                        v-validate="'required'"
                        :name="`Masa Berlaku Perizinan Berusaha ${index + 1}`"
                      ></b-form-input>
                      <div class="text-units">
                        <span>{{ data.masa_berlaku }}</span>
                        <span> tahun</span>
                      </div>
                    </div>
                    <span
                      class="text-danger"
                      v-if="
                        errors.has(
                          `Masa Berlaku Perizinan Berusaha ${index + 1}`
                        )
                      "
                    >
                      {{
                        errors.first(
                          `Masa Berlaku Perizinan Berusaha ${index + 1}`
                        )
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-3">
              <label> Upload dokumentasi/bukti dukung </label>
              <div class="row">
                <div>
                  <small>Format file: PDF, Ukuran maksimal: 5MB</small>
                </div>
                <div class="col-6">
                  <b-form-file
                    v-model="data.dokumentasi"
                    :id="`b_dokumentasi_${index + 1}`"
                    plain
                    class="form-control"
                    :name="`b. Dokumentasi ${index + 1}`"
                    accept=".pdf"
                    @change="checkFileSize($event, `dokumentasi-b${index}`)"
                    :disabled="is_selesai"
                  ></b-form-file>
                </div>
                <div v-if="b_url_dokumentasi[index]" class="col-6 d-flex">
                  <a
                    :class="{
                      'btn btn-success': true,
                      disabled: b_url_dokumentasi[index] === null,
                    }"
                    :href="b_url_dokumentasi[index]"
                    target="_blank"
                  >
                    <i class="fa fa-download" />
                    Unduh
                  </a>
                </div>
              </div>
              <span
                class="text-danger"
                v-if="errors.has(`Dokumentasi ${index + 1}`)"
              >
                {{ errors.first(`Dokumentasi ${index + 1}`) }}
              </span>
              <span
                class="text-danger"
                v-if="errors.has(`dokumentasi-b${index}`, 'custom')"
              >
                {{ errors.first(`dokumentasi-b${index}`, 'custom') }}
              </span>
              <b-button
                v-if="form.data_perizinan_berusaha.length > 1 && !is_selesai"
                @click="removePerizinanBerusaha(index)"
                variant="danger"
                class="mt-3"
              >
                <i class="fa fa-trash" />
                Hapus Perizinan Berusaha {{ index + 1 }}
              </b-button>
            </div>
          </div>
        </div>
      </template>

      <div v-if="!is_selesai" class="row mb-1 pb-3 border-bottom g-0">
        <div v-if="form.perizinan_berusaha === 'Sudah'" class="col-12">
          <b-button
            @click="addPerizinanBerusaha"
            variant="secondary"
            class="me-1"
          >
            <i class="fa fa-plus" />
            Tambah Perizinan Berusaha
          </b-button>
        </div>
      </div>
    </template>

    <template v-if="jenis_kegiatan === 'Non Berusaha'">
      <div class="row mb-3 mt-3">
        <div :class="['col-md-6', { 'pe-none': is_selesai }]">
          <div class="row gx-3">
            <div class="col-12">
              <label class="fw-bold">
                b. perizinan non berusaha
                <span class="text-danger">*</span></label
              >
              <div class="w-50 pe-2">
                <v-select
                  v-model="form.perizinan_nonberusaha"
                  id="b_perizinan_berusaha"
                  :reduce="(data) => data.value"
                  label="text"
                  :options="optionPerizinanNonberusaha"
                  name="Perizinan Non Berusaha"
                  v-validate="'required'"
                />
              </div>
              <span
                class="text-danger"
                v-if="errors.has('Perizinan Non Berusaha')"
              >
                {{ errors.first('Perizinan Non Berusaha') }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <template v-if="form.perizinan_nonberusaha === 'Sudah'">
        <div
          v-for="(data, index) in form.data_perizinan_nonberusaha"
          :key="index"
        >
          <div v-if="index !== 0" class="row border-bottom g-0 mb-3"></div>
          <div class="row mb-3">
            <div :class="['col-md-6', { 'pe-none': is_selesai }]">
              <div class="row gx-3">
                <div class="fw-bold">
                  Perizinan Non Berusaha {{ index + 1 }}
                </div>
                <div class="row">
                  <div></div>
                  <div class="col-6 mt-3 g-3">
                    <label
                      >Nomor Perizinan Non Berusaha {{ index + 1 }}
                      <span class="text-danger">*</span></label
                    >
                    <b-form-input
                      v-model="data.nomor_perizinan"
                      :id="`b_nomor_perizinan_${index + 1}`"
                      v-validate="'required'"
                      :name="`Nomor Perizinan Non Berusaha ${index + 1}`"
                    ></b-form-input>
                    <span
                      class="text-danger"
                      v-if="
                        errors.has(`Nomor Perizinan Non Berusaha ${index + 1}`)
                      "
                    >
                      {{
                        errors.first(
                          `Nomor Perizinan Non Berusaha ${index + 1}`
                        )
                      }}
                    </span>
                  </div>
                  <div class="col-6 mt-3 g-3">
                    <label
                      >Tanggal Terbit Perizinan Non Berusaha {{ index + 1 }}
                      <span class="text-danger">*</span></label
                    >
                    <DatePicker
                      :id="`b_tgl_terbit_${index + 1}`"
                      lang="en"
                      :placeholder="c_tgl_terbit[index]"
                      input-class="form-control"
                      @change="
                        (e) => {
                          changeDatePerizinanNonBerusaha(e, index)
                        }
                      "
                      class="w-100"
                    >
                      <i class="fa fa-calendar-o" slot="calendar-icon" />
                    </DatePicker>
                    <span
                      class="text-danger"
                      v-if="
                        errors.has(
                          `Tanggal Terbit Perizinan Non Berusaha ${index + 1}`
                        )
                      "
                    >
                      {{
                        errors.first(
                          `Tanggal Terbit Perizinan Non Berusaha ${index + 1}`
                        )
                      }}
                    </span>
                  </div>
                  <div class="col-6 mt-3 g-3">
                    <label
                      >Instansi Penerbit Perizinan Non Berusaha {{ index + 1 }}
                      <span class="text-danger">*</span></label
                    >
                    <b-form-input
                      v-model="data.instansi_penerbit"
                      :id="`b_instansi_penerbit_${index + 1}`"
                      v-validate="'required'"
                      :name="`Instansi Penerbit Perizinan Non Berusaha ${
                        index + 1
                      }`"
                    ></b-form-input>
                    <span
                      class="text-danger"
                      v-if="
                        errors.has(
                          `Instansi Penerbit Perizinan Non Berusaha ${
                            index + 1
                          }`
                        )
                      "
                    >
                      {{
                        errors.first(
                          `Instansi Penerbit Perizinan Non Berusaha ${
                            index + 1
                          }`
                        )
                      }}
                    </span>
                  </div>
                  <div class="col-6 mt-3 g-3">
                    <label
                      >Masa Berlaku Perizinan Non Berusaha
                      {{ index + 1 }} (tahun)
                      <span class="text-danger">*</span></label
                    >
                    <div class="input-units">
                      <b-form-input
                        v-model="data.masa_berlaku"
                        :id="`b_masa_berlaku_${index + 1}`"
                        v-mask="integerMask(data.masa_berlaku)"
                        v-validate="'required'"
                        :name="`Masa Berlaku Perizinan Non Berusaha ${
                          index + 1
                        }`"
                      ></b-form-input>
                      <div class="text-units">
                        <span>{{ data.masa_berlaku }}</span>
                        <span> tahun</span>
                      </div>
                    </div>
                    <span
                      class="text-danger"
                      v-if="
                        errors.has(
                          `Masa Berlaku Perizinan Non Berusaha ${index + 1}`
                        )
                      "
                    >
                      {{
                        errors.first(
                          `Masa Berlaku Perizinan Non Berusaha ${index + 1}`
                        )
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-3">
              <label> Upload dokumentasi/bukti dukung </label>
              <div class="row">
                <div>
                  <small>Format file: PDF, Ukuran maksimal: 5MB</small>
                </div>
                <div class="col-6">
                  <b-form-file
                    v-model="data.dokumentasi"
                    :id="`b_dokumentasi_${index + 1}`"
                    plain
                    class="form-control"
                    :name="`b. Dokumentasi ${index + 1}`"
                    accept=".pdf"
                    @change="checkFileSize($event, `dokumentasi-b${index}`)"
                    :disabled="is_selesai"
                  ></b-form-file>
                </div>
                <div v-if="c_url_dokumentasi[index]" class="col-6 d-flex">
                  <a
                    :class="{
                      'btn btn-success': true,
                      disabled: c_url_dokumentasi[index] === null,
                    }"
                    :href="c_url_dokumentasi[index]"
                    target="_blank"
                  >
                    <i class="fa fa-download" />
                    Unduh
                  </a>
                </div>
              </div>
              <span
                class="text-danger"
                v-if="errors.has(`Dokumentasi ${index + 1}`)"
              >
                {{ errors.first(`Dokumentasi ${index + 1}`) }}
              </span>
              <span
                class="text-danger"
                v-if="errors.has(`dokumentasi-b${index}`, 'custom')"
              >
                {{ errors.first(`dokumentasi-b${index}`, 'custom') }}
              </span>
              <b-button
                v-if="form.data_perizinan_nonberusaha.length > 1 && !is_selesai"
                @click="removePerizinanNonBerusaha(index)"
                variant="danger"
                class="mt-3"
              >
                <i class="fa fa-trash" />
                Hapus Perizinan Non Berusaha {{ index + 1 }}
              </b-button>
            </div>
          </div>
        </div>
      </template>

      <div v-if="!is_selesai" class="row mb-1 pb-3 border-bottom g-0">
        <div v-if="form.perizinan_nonberusaha === 'Sudah'" class="col-12">
          <b-button
            @click="addPerizinanNonBerusaha"
            variant="secondary"
            class="me-1"
          >
            <i class="fa fa-plus" />
            Tambah Perizinan Non Berusaha
          </b-button>
        </div>
      </div>
    </template>

    <div :class="[{ 'pe-none': is_selesai }]">
      <label>Keterangan/Catatan lain</label>
      <ckeditor
        id="keterangan_kemajuan_perizinan"
        :editor="wygEditor"
        v-model="form.keterangan"
      ></ckeditor>
    </div>

    <div class="mt-5 fw-bold">
      Note: tanda (<span class="text-danger">*</span>) wajib diisi
    </div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import DatePicker from 'vue2-datepicker'
import { formatDate } from '../../helper/helpernew'
import Vue from 'vue'
import { decimalMask, integerMask } from '../../helper/validationHelper'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      form: {
        persetujuan_lingkungan: 'Sudah',
        a_dokumentasi: null,
        a_nomor_perizinan: '',
        a_tgl_terbit: null,
        a_instansi_penerbit: '',
        a_masa_berlaku: '0',
        perizinan_berusaha: 'Sudah',
        data_perizinan_berusaha: [
          {
            id: null,
            dokumentasi: null,
            nomor_perizinan: '',
            tgl_terbit: null,
            instansi_penerbit: '',
            masa_berlaku: '0',
          },
        ],
        perizinan_nonberusaha: 'Sudah',
        data_perizinan_nonberusaha: [
          {
            id: null,
            dokumentasi: null,
            nomor_perizinan: '',
            tgl_terbit: null,
            instansi_penerbit: '',
            masa_berlaku: '0',
          },
        ],
        c_dokumentasi: null,
        c_nomor_perizinan: '',
        c_tgl_terbit: null,
        c_instansi_penerbit: '',
        c_masa_berlaku: '0',
        keterangan: '',
      },
      a_tgl_terbit: 'dd/mm/yyyy',
      b_tgl_terbit: ['dd/mm/yyyy'],
      c_tgl_terbit: ['dd/mm/yyyy'],
      a_url_dokumentasi: null,
      b_url_dokumentasi: [],
      c_url_dokumentasi: [],
      optionPersetujuanLingkungan: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum Terbit', text: 'Belum Terbit' },
      ],
      optionPerizinanBerusaha: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum Terbit', text: 'Belum Terbit' },
      ],
      optionPerizinanNonberusaha: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum Terbit', text: 'Belum Terbit' },
      ],
      wygEditor: ClassicEditor,
      is_selesai: false,
      jenis_kegiatan: null,
    }
  },
  mounted() {
    this.loadLaporanTahunan()
  },
  methods: {
    decimalMask,
    integerMask,
    formatDate,

    changeDatePerizinanBerusaha(val, index) {
      this.errors.remove(`Tanggal Terbit Perizinan Berusaha ${index + 1}`)
      Vue.set(this.b_tgl_terbit, index, val.toLocaleDateString('en-GB'))
      this.form.data_perizinan_berusaha[index].tgl_terbit = formatDate(
        val,
        'YYYY-MM-DD'
      )
    },

    addPerizinanBerusaha() {
      this.form.data_perizinan_berusaha.push({
        id: null,
        dokumentasi: null,
        nomor_perizinan: '',
        tgl_terbit: null,
        instansi_penerbit: '',
        masa_berlaku: '0',
      })
      this.b_tgl_terbit.push('dd/mm/yyyy')
      this.b_url_dokumentasi.push(null)
    },

    async removePerizinanBerusaha(i) {
      const idPerizinan = this.form.data_perizinan_berusaha[i].id
      if (idPerizinan !== null) {
        await axios.delete(
          this.baseapi +
            'api/laporan_perizinan_berusaha/' +
            this.form.data_perizinan_berusaha[i].id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
      }
      this.form.data_perizinan_berusaha.splice(i, 1)
      this.b_tgl_terbit.splice(i, 1)
      this.b_url_dokumentasi.splice(i, 1)
    },

    changeDatePerizinanNonBerusaha(val, index) {
      this.errors.remove(`Tanggal Terbit Perizinan Non Berusaha ${index + 1}`)
      Vue.set(this.c_tgl_terbit, index, val.toLocaleDateString('en-GB'))
      this.form.data_perizinan_nonberusaha[index].tgl_terbit = formatDate(
        val,
        'YYYY-MM-DD'
      )
    },

    addPerizinanNonBerusaha() {
      this.form.data_perizinan_nonberusaha.push({
        id: null,
        dokumentasi: null,
        nomor_perizinan: '',
        tgl_terbit: null,
        instansi_penerbit: '',
        masa_berlaku: '0',
      })
      this.c_tgl_terbit.push('dd/mm/yyyy')
      this.c_url_dokumentasi.push(null)
    },

    async removePerizinanNonBerusaha(i) {
      const idPerizinan = this.form.data_perizinan_nonberusaha[i].id
      if (idPerizinan !== null) {
        await axios.delete(
          this.baseapi +
            'api/laporan_perizinan_nonberusaha/' +
            this.form.data_perizinan_nonberusaha[i].id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
      }
      this.form.data_perizinan_nonberusaha.splice(i, 1)
      this.c_tgl_terbit.splice(i, 1)
      this.c_url_dokumentasi.splice(i, 1)
    },

    async nextForm() {
      this.resetFormError()

      if (this.is_selesai) {
        return true
      }

      if (
        this.form.persetujuan_lingkungan === 'Sudah' &&
        this.form.a_tgl_terbit === null
      ) {
        this.addFormError('Tanggal Terbit')
      }
      if (this.jenis_kegiatan === 'Berusaha') {
        for (let i = 0; i < this.form.data_perizinan_berusaha.length; i++) {
          if (
            this.form.perizinan_berusaha === 'Sudah' &&
            this.form.data_perizinan_berusaha[i].tgl_terbit === null
          ) {
            this.addFormError(`Tanggal Terbit Perizinan Berusaha ${i + 1}`)
          }
        }
      }
      if (this.jenis_kegiatan === 'Non Berusaha') {
        for (let i = 0; i < this.form.data_perizinan_nonberusaha.length; i++) {
          if (
            this.form.perizinan_nonberusaha === 'Sudah' &&
            this.form.data_perizinan_nonberusaha[i].tgl_terbit === null
          ) {
            this.addFormError(`Tanggal Terbit Perizinan Non Berusaha ${i + 1}`)
          }
        }
      }

      if ((await this.$validator.validateAll()) && !this.errors.any()) {
        this.$loading(true)
        const formData = new FormData()
        // prettier-ignore
        {
          // persetujuan lingkungan
          formData.append('status_persetujuan_lingkungan', this.form.persetujuan_lingkungan)
          formData.append('catatan_kemajuan_perizinan', this.form.keterangan)
          if (this.form.persetujuan_lingkungan === 'Sudah') {
            formData.append('nomor_persetujuan_lingkungan', this.form.a_nomor_perizinan)
            formData.append('tanggal_terbit_persetujuan_lingkungan', this.form.a_tgl_terbit)
            formData.append('instansi_penerbit_persetujuan_lingkungan', this.form.a_instansi_penerbit)
            formData.append('masa_berlaku_persetujuan_lingkungan', parseFloat(this.form.a_masa_berlaku))
          }
          if (this.form.a_dokumentasi) {
            formData.append('file_persetujuan_lingkungan', this.form.a_dokumentasi)
          }
          if (this.jenis_kegiatan === 'Berusaha') {
            formData.append('status_perizinan_berusaha', this.form.perizinan_berusaha)
          }
          if (this.jenis_kegiatan === 'Non Berusaha') {
            formData.append('status_perizinan_nonberusaha', this.form.perizinan_nonberusaha)
          }
        }

        try {
          await axios.post(
            this.baseapi +
              `api/laporan_tahunan/${this.$route.query.id_laporan}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )

          if (this.jenis_kegiatan === 'Berusaha') {
            if (this.form.perizinan_berusaha === 'Sudah') {
              for (const x of this.form.data_perizinan_berusaha) {
                const formData = new FormData()
                // prettier-ignore
                {
                  formData.append('id_laporan_tahunan', this.$route.query.id_laporan)
                  formData.append('nomor_perizinan_berusaha', x.nomor_perizinan)
                  formData.append('tanggal_terbit_perizinan_berusaha', x.tgl_terbit)
                  formData.append('instansi_penerbit_perizinan_berusaha', x.instansi_penerbit)
                  formData.append('masa_berlaku_perizinan_berusaha', x.masa_berlaku)
                  if (x.dokumentasi !== null) {
                    formData.append('file_perizinan_berusaha', x.dokumentasi)
                  }
                }
                await axios.post(
                  this.baseapi +
                    'api/laporan_perizinan_berusaha' +
                    (x.id !== null ? `/${x.id}` : ''),
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      Authorization: `Bearer ` + this.user.accessToken,
                    },
                  }
                )
              }
            } else {
              for (const x of this.form.data_perizinan_berusaha) {
                if (x.id !== null) {
                  await axios.delete(
                    this.baseapi + 'api/laporan_perizinan_berusaha/' + x.id,
                    {
                      headers: {
                        Authorization: `Bearer ` + this.user.accessToken,
                      },
                    }
                  )
                }
              }
            }
          }
          if (this.jenis_kegiatan === 'Non Berusaha') {
            if (this.form.perizinan_nonberusaha === 'Sudah') {
              for (const x of this.form.data_perizinan_nonberusaha) {
                const formData = new FormData()
                // prettier-ignore
                {
                    formData.append('id_laporan_tahunan', this.$route.query.id_laporan)
                    formData.append('nomor_perizinan_nonberusaha', x.nomor_perizinan)
                    formData.append('tanggal_terbit_perizinan_nonberusaha', x.tgl_terbit)
                    formData.append('instansi_penerbit_perizinan_nonberusaha', x.instansi_penerbit)
                    formData.append('masa_berlaku_perizinan_nonberusaha', x.masa_berlaku)
                    if (x.dokumentasi !== null) {
                      formData.append('file_perizinan_nonberusaha', x.dokumentasi)
                    }
                  }
                await axios.post(
                  this.baseapi +
                    'api/laporan_perizinan_nonberusaha' +
                    (x.id !== null ? `/${x.id}` : ''),
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      Authorization: `Bearer ` + this.user.accessToken,
                    },
                  }
                )
              }
            } else {
              for (const x of this.form.data_perizinan_nonberusaha) {
                if (x.id !== null) {
                  await axios.delete(
                    this.baseapi + 'api/laporan_perizinan_nonberusaha/' + x.id,
                    {
                      headers: {
                        Authorization: `Bearer ` + this.user.accessToken,
                      },
                    }
                  )
                }
              }
            }
          }
          Swal.fire(
            'Berhasil',
            'Kemajuan Perizinan Laporan Tahunan tersimpan',
            'success'
          )
          return true
        } catch (error) {
          Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
          return false
        } finally {
          this.$loading(false)
        }
      } else {
        return false
      }
    },

    addFormError(fieldName) {
      this.errors.add({
        field: fieldName,
        msg: `${fieldName} wajib diisi`,
      })
    },

    resetFormError() {
      this.errors.clear()
    },

    async loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      try {
        const req = await axios.get(
          this.baseapi + `api/laporan_tahunan/${this.$route.query.id_laporan}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        const data = req.data.data
        this.is_selesai =
          data.status_laporan !== null &&
          data.status_laporan !== 'Draft' &&
          data.status_laporan !==
            'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
        // prettier-ignore
        this.form = {
          ...this.form,
          persetujuan_lingkungan: data.status_persetujuan_lingkungan || 'Sudah',
          a_dokumentasi: null,
          a_nomor_perizinan: data.nomor_persetujuan_lingkungan || '',
          a_tgl_terbit: data.tanggal_terbit_persetujuan_lingkungan || null,
          a_instansi_penerbit: data.instansi_penerbit_persetujuan_lingkungan || '',
          a_masa_berlaku: String(data.masa_berlaku_persetujuan_lingkungan) || '0',
          perizinan_berusaha: data.status_perizinan_berusaha || 'Sudah',
          perizinan_nonberusaha: data.status_perizinan_nonberusaha || 'Sudah',
          keterangan: data.catatan_kemajuan_perizinan || ''
        }
        // prettier-ignore
        {
          this.a_tgl_terbit = this.form.a_tgl_terbit ? formatDate(this.form.a_tgl_terbit, 'DD/MM/YYYY') : 'dd/mm/yyyy'
          this.a_url_dokumentasi = data.file_persetujuan_lingkungan
          this.jenis_kegiatan = data.jenis_kegiatan
        }

        if (this.jenis_kegiatan === 'Berusaha') {
          const req = await axios.get(
            this.baseapi +
              `api/laporan_perizinan_berusaha?filter=id_laporan_tahunan,=,${data.id}&sort=createdAt,ASC`,
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          const data2 = req.data.data
          if (data2.length === 0) return
          const res = []
          const res_tgl = []
          const res_url = []
          for (const x of data2) {
            res.push({
              id: x.id,
              dokumentasi: null,
              nomor_perizinan: x.nomor_perizinan_berusaha,
              tgl_terbit: x.tanggal_terbit_perizinan_berusaha,
              instansi_penerbit: x.instansi_penerbit_perizinan_berusaha,
              masa_berlaku: String(x.masa_berlaku_perizinan_berusaha),
            })
            res_tgl.push(
              formatDate(x.tanggal_terbit_perizinan_berusaha, 'DD/MM/YYYY')
            )
            res_url.push(x.file_perizinan_berusaha)
          }
          this.form.data_perizinan_berusaha = res
          this.b_tgl_terbit = res_tgl
          this.b_url_dokumentasi = res_url
        }
        if (this.jenis_kegiatan === 'Non Berusaha') {
          const req = await axios.get(
            this.baseapi +
              `api/laporan_perizinan_nonberusaha?filter=id_laporan_tahunan,=,${data.id}&sort=createdAt,ASC`,
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          const data2 = req.data.data
          if (data2.length === 0) return
          const res = []
          const res_tgl = []
          const res_url = []
          for (const x of data2) {
            res.push({
              id: x.id,
              dokumentasi: null,
              nomor_perizinan: x.nomor_perizinan_nonberusaha,
              tgl_terbit: x.tanggal_terbit_perizinan_nonberusaha,
              instansi_penerbit: x.instansi_penerbit_perizinan_nonberusaha,
              masa_berlaku: String(x.masa_berlaku_perizinan_nonberusaha),
            })
            res_tgl.push(
              formatDate(x.tanggal_terbit_perizinan_nonberusaha, 'DD/MM/YYYY')
            )
            res_url.push(x.file_perizinan_nonberusaha)
          }
          this.form.data_perizinan_nonberusaha = res
          this.c_tgl_terbit = res_tgl
          this.c_url_dokumentasi = res_url
        }
      } finally {
        this.$loading(false)
      }
    },

    checkFileSize(e, field) {
      const file = e.target.files[0]
      const maxSize = 5 * 1024 * 1024

      if (file && file.size > maxSize) {
        this.errors.add({
          field: field,
          msg: 'Ukuran file maksimal 5MB',
          scope: 'custom',
        })
      } else {
        this.errors.remove(field, 'custom')
      }
    },
  },
}
</script>
